import { COLOR_VARS } from "@/lib/boo-colors";
import { cn } from "@/lib/utils";
import type { CSSProperties } from "react";

// FNV-1a: a stable small hash so a Boo keeps its colors across visits.
function hash(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/**
 * A Boo's own mark: the brand blob, still, in two colors picked from the
 * brand palette by the Boo's id, so the same Boo looks the same on the map,
 * its cards and everywhere else.
 */
export function BooMark({ id, className, muted }: { id: string; className?: string; muted?: boolean }) {
  const h = hash(id);
  const i = h % COLOR_VARS.length;
  const a = COLOR_VARS[i];
  // A different hue several steps away keeps the pair readable.
  const b = COLOR_VARS[(i + 3 + ((h >>> 8) % 6)) % COLOR_VARS.length];
  const style: CSSProperties = {
    backgroundImage: `linear-gradient(135deg, var(${a}), var(${b}))`,
    borderRadius: "54% 46% 47% 53% / 51% 47% 53% 49%",
  };
  return (
    <span
      aria-hidden
      className={cn("inline-block shrink-0 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.08)]", muted && "opacity-50 grayscale", className)}
      style={style}
    />
  );
}
